import { AccountingFieldsAggregate } from 'wflow-main-app/src/app/domains/accounting-validations/aggregates/accounting-fields.aggregate';
import { VALIDATION_FIELDS_ACCOUNTING } from 'wflow-main-app/src/app/pages/org/pages/documents/__const/validation/validation-fields.const';
import {
  AccountingFieldItem,
  IntegrationField,
} from 'wflow-main-app/src/app/store/integrations/integration.model';

export const ACCOUNTING_VALIDATION_DEFAULTS: AccountingFieldItem =
  AccountingFieldsAggregate.create();

export const ACCOUNTING_VALIDATION_FIELD_CAPTIONS: IntegrationField[] =
  Object.keys(VALIDATION_FIELDS_ACCOUNTING).map((key) => ({
    name: key,
    label: VALIDATION_FIELDS_ACCOUNTING[key],
  }));
